import { LyraTheme as theme } from 'src/components/theme/lyra/Theme';
import FormInputSelect, { Props as SelectProps } from '../forms/inputs/FormInputSelect';
import { MenuProps } from '@mui/material';

const LyraInputSelectMenuProps: Partial<MenuProps> = {
  sx: {
    '.MuiPaper-root': {
      'box-shadow': '0px 4px 4px 0px rgba(0, 0, 0, 0.25);',
      border: '1px solid rgba(0, 0, 0, 0.15)',
      borderRadius: '12px',
    },
    '& .MuiMenuItem-root': {
      padding: `8px 16px`,
      whiteSpace: 'pre-wrap',
      minHeight: 'auto',
      '&:hover': {
        backgroundColor: 'rgba(0, 70, 254, 0.12)',
      },
    },
    '& .Mui-focusVisible': {
      backgroundColor: 'rgba(0, 70, 254, 0.12)',
    },
  },
};

export const LyraFormInputSelect = ({ ...props }: SelectProps): JSX.Element => {
  return (
    <FormInputSelect
      {...props}
      sx={{
        '&.MuiOutlinedInput-root': {
          borderRadius: theme.spacing(1.5),
          background: 'white',
        },
        '.MuiOutlinedInput-notchedOutline': { borderColor: 'grey.900' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'grey.900',
        },
      }}
      menuProps={{
        sx: { ...LyraInputSelectMenuProps.sx },
      }}
    />
  );
};
